import { combineReducers } from 'redux'

import supply from './industry/supply'
import profile from './industry/profile'
import choosing from './industry/choosing'

const industry = combineReducers({
  supply,
  profile,
  choosing
})

export default industry
